// extracted by mini-css-extract-plugin
export default {"formInputBox":"index_formInputBox_kTqMk","formInput":"index_formInput_aZ7Ok","formInputValue2":"index_formInputValue2_mzEWz"};